import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import ContactInfo from './section-components/contact-info';
import ContactForm from './section-components/contact-form';
import Footer from './global-components/footer';

const ContactPage = () => {
    return <div className='booth-background'>
        <Navbar />
        <PageHeader headertitle="Contacto"  />
        <ContactInfo />
        <ContactForm />
        <Footer />
    </div>
}

export default ContactPage

